module.exports = __webpack_public_path__ + "static/media/Livre5.88b6a5b4.png";